import React, { useEffect, createElement } from 'react';
/**
 * Performance helper:
 *
 * 1. Warms up DNS + TLS to third-party origins so the first real
 *    request to each domain skips the handshake.
 * 2. Pre-resolves the checkout domain so CTA clicks navigate instantly.
 *
 * Critical origins (fonts, image CDN) get `preconnect`; secondary ones
 * get the lighter `dns-prefetch`.
 */
export function LinkPreloader() {
  useEffect(() => {
    const head = document.head;
    const created: HTMLLinkElement[] = [];
    const add = (rel: string, href: string, crossOrigin?: string) => {
      const existing = head.querySelector(`link[rel="${rel}"][href="${href}"]`);
      if (existing) return;
      const link = document.createElement('link');
      link.rel = rel;
      link.href = href;
      if (crossOrigin) link.crossOrigin = crossOrigin;
      head.appendChild(link);
      created.push(link);
    };
    // Google Fonts — both endpoints, both need crossorigin
    add('preconnect', 'https://fonts.googleapis.com');
    add('preconnect', 'https://fonts.gstatic.com', 'anonymous');
    // Image CDN that serves the hero mockup + content previews
    add('preconnect', 'https://cdn.magicpatterns.com', 'anonymous');
    // Meta Pixel network — preconnect so when the deferred pixel
    // boots, it doesn't pay TLS cost on top of script latency
    add('dns-prefetch', 'https://connect.facebook.net');
    add('dns-prefetch', 'https://www.facebook.com');
    // Checkout — warms up before the user clicks a CTA
    add('dns-prefetch', 'https://mega-pack-kinesiologia.impultienda.ar');
    add('preconnect', 'https://mega-pack-kinesiologia.impultienda.ar', 'anonymous');
    return () => {
      created.forEach(l => l.parentNode?.removeChild(l));
    };
  }, []);
  return null;
}